import { get, put } from '~/utils/ajax'
import { AssetsAPI } from '~/api/epay-template/contracts'
import { apiCheck } from '~/api'
export * from './contracts'

export const getAssets = async (shopId: string): Promise<AssetsAPI> => apiCheck(await get<AssetsAPI>(`assets/payment-page?id=${shopId}`))

export const updateAssets = async (newAssets, shopId: string): Promise<AssetsAPI> => apiCheck(await put<AssetsAPI>(`assets/payment-page?id=${shopId}`, newAssets))
